import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/64/thumb-landscape.jpg"

const Post64 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>トレンドがめまぐるしく移り変わるファッションの世界で、「何年経っても古くならないバッグ」は意外と少ないものです。</p>
          <p>そんな中、静かなブームを超えて“定番”として確固たる地位を築いているのが、<br></br><b className="text-font-bolder">ヴァレクストラ《イジィデ（Iside）》</b>です。</p>
          <p>ロゴで主張するのではなく、<br></br>
          端正なフォルムと卓越したレザーの質感で語るデザインは、<br></br>
          30代後半〜50代の大人の女性を中心に、長く支持され続けています。</p>
          <p>本記事では、イジィデを支持する年齢層、人気の理由、サイズ比較、冬のコーディネート提案まで、じっくりと掘り下げます。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;イジィデを支持している年齢層は？</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec2" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;30代｜初めて迎える「本物志向」のバッグ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;40代｜装いを整える「信頼できる定番」のバッグ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;50代｜「自分らしさ」を静かに表現するバッグ</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;なぜイジィデのバッグはこんなにも人気なのか？</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec6" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;建築的で完成度の高いフォルム</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ロゴに頼らない“知性のラグジュアリー”</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;シーンを選ばない万能性</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec9" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;『イジィデ』シリーズ サイズ比較</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec10" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;マイクロ イジィデ｜アクセサリー感覚で楽しむ最小サイズ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec11" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミニ イジィデ｜初めてのイジィデに選ばれる王道サイズ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec12" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム イジィデ｜仕事にも対応できる大人の実用サイズ</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec13" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;サイズ違いで広がる、イジィデのコーディネート術</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec14" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;マイクロ イジィデ｜会食・レストランシーンに</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec15" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;マイクロ イジィデ｜週末のお出かけ・近場外出に</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec16" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミニ イジィデ｜通勤・仕事帰りの予定がある日に</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec17" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミニ イジィデ｜ショッピング・街歩きに</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec18" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム イジィデ｜通勤・学校行事などきちんとした日に</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec19" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム イジィデ｜休日のお出かけ・長時間の外出に</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec20" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;イジィデの「カラーバリエーション」定番色から選ぶ大人の最適解</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec21" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;Pergamena White — ヴァレクストラを象徴するカラー</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec22" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;Black — シーンを選ばない不動の定番カラー</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec23" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;Gray — 洗練と柔らかさを兼ね備えた万能カラー</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec24" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>6 |</span>&nbsp;&nbsp;まとめ：イジィデは「今」ではなく「これから」を支えるバッグ</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/64/1.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>イジィデを支持している年齢層は？</h2>
        </div>
        <p>イジィデを愛用している中心層は、30代後半〜50代の女性です。流行を追いかけるよりも、自分のスタイルや価値観を大切にしながら、長く使える上質なものを選びたいと考える世代から、特に高い支持を集めています。</p>
        <p>目立つロゴで主張するバッグよりも、素材の良さや仕立ての美しさが伝わる、控えめで洗練されたデザインを好む方にとって、イジィデは理想的な存在です。また、仕事の場面からプライベート、フォーマルなシーンまで、バッグを持ち替えることなく対応できる汎用性の高さも、多忙な大人の女性に選ばれる理由のひとつです。</p>
        <p>20代では「いつかは持ちたい憧れのバッグ」として認識されることが多く、30代で初めてイジィデを迎え入れ、40代以降になるとサイズ違いやカラー違いを買い足していく、という流れも決して珍しくありません。</p>
        <p>イジィデは、年齢やライフステージの変化に寄り添いながら、持つ人の魅力を引き立ててくれるバッグです。憧れから始まり、信頼へと変わっていく——その過程を自然に受け止めてくれる点こそが、世代を超えて選ばれ続ける理由と言えるでしょう。</p>
        <div name="sec2" className="text-img-cloumn-main mt8">
          <figure className="img-xs">
            <StaticImage src="../../images/posts/64/2.jpg" alt=""/>
          </figure>
          <div>
            <h3>◆ 30代｜初めて迎える「本物志向」のバッグ</h3>
            <p>30代になると、イジィデは現実的な選択肢として選ばれ始めます。<br></br>
            仕事、プライベート、フォーマルな場面が交差するライフスタイルの中で、シーンを問わず使える汎用性の高さが評価されます。</p>
            <p>トレンドよりも「長く使えるかどうか」を重視し始める世代にとって、イジィデは“本物志向”への入り口となるバッグです。</p>
          </div>
        </div>
        <div name="sec3" className="text-img-cloumn-main">
          <figure className="img-xs">
            <StaticImage src="../../images/posts/64/3.jpg" alt=""/>
          </figure>
          <div>
            <h3>◆ 40代｜装いを整える「信頼できる定番」のバッグ</h3>
            <p>40代の女性にとってイジィデは、装いを確実に整えてくれる存在です。<br></br>
            派手さよりも品の良さ、主張よりも完成度を重視するようになり、素材や仕立ての美しさがより重要な判断基準になります。</p>
            <p>仕事、学校行事、会食など幅広いシーンに対応できるため、「迷ったときに選べば間違いないバッグ」として定着。</p>
            <p>サイズ違いやカラー違いで買い足す方も増えていきます。</p>
          </div>
        </div>
        <div name="sec4" className="text-img-cloumn-main">
          <figure className="img-xs">
            <StaticImage src="../../images/posts/64/4.jpg" alt=""/>
          </figure>
          <div>
            <h3>◆ 50代｜「自分らしさ」を静かに表現するバッグ</h3>
            <p>50代になると、バッグ選びはさらにシンプルで明確になります。<br></br>
            ブランドを誇示するのではなく、自分のスタイルや生き方を自然に表現できるかどうかが重視されるようになります。</p>
            <p>イジィデの静かな存在感と構築的な美しさは、経験を重ねた大人の女性の佇まいとよく調和し、装いに無理のない品格を添えてくれます。</p>
            <p>長く付き合える定番として、安心して持ち続けられる点が支持される理由です。</p>
          </div>
        </div>
      </section>
      <section name="sec5" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/64/5.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>なぜイジィデのバッグはこんなにも人気なのか？</h2>
        </div>
        <p>イジィデがこれほどまでに支持されている理由は、デザイン性・品質・実用性のすべてが、非常に高いレベルで調和している点にあります。</p>
        <p>建築的で完成度の高いフォルムは流行に左右されず、ロゴに頼らない佇まいは持つ人の品格や審美眼をさりげなく引き立てます。さらに、オン・オフ・フォーマルを問わず使える汎用性は、忙しい大人の女性にとって大きな安心感につながります。</p>
        <p>一時的なトレンドや話題性ではなく、「この先も変わらず使い続けたい」と思わせる普遍性こそが、イジィデの最大の価値です。</p>
        <p>持つたびにその良さを実感し、年齢やライフステージの変化にも自然と寄り添ってくれる――<br></br>
        だからこそ、イジィデは、長く愛され、何度も選ばれ続けているのです。</p>
        <div name="sec6" className="mt8">
          <div>
            <h3>◆ 建築的で完成度の高いフォルム</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/64/6.jpg" alt=""/>
            </figure>
            <div>
              <p>イジィデ最大の特徴は、ピラミッド型の端正で無駄のないシルエットにあります。</p>
              <p>直線と面で構成された立体的なフォルムは、どの角度から見てもバランスが美しく、手に持ったときはもちろん、テーブルや床に置いた状態でも自然と視線を集めます。<br></br>
              その造形美は、イタリア建築に見られる幾何学的な美しさや構造美へのオマージュから生まれたものです。</p>
              <p>流行に左右されない完成度の高さが、長く愛され続ける理由となっています。</p>
            </div>
          </div>
        </div>
        <div name="sec7" className="mt4">
          <div>
            <h3>◆ ロゴに頼らない“知性のラグジュアリー”</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/64/7.jpg" alt=""/>
            </figure>
            <div>
              <p>イジィデの表情は驚くほど静かで、目立つロゴや過剰な装飾は一切ありません。</p>
              <p>それでも一目で「良いバッグ」と感じさせるのは、レザーの張り感や均一で美しいコバの処理、開閉金具の精度といった、細部に宿る圧倒的なクオリティがあるからです。</p>
              <p>ブランドを声高に主張しないからこそ生まれる、“分かる人には分かる”という距離感。</p>
              <p>この控えめなラグジュアリー感が、経験を重ねた大人の女性の感性に深く響きます。</p>
            </div>
          </div>
        </div>
        <div name="sec8" className="mt4">
          <div>
            <h3>◆ シーンを選ばない万能性</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/64/8.jpg" alt=""/>
            </figure>
            <div>
              <p>イジィデは、通勤スタイルから学校行事、レストランでの会食、さらには式典やフォーマルな場まで、幅広いシーンに自然と溶け込みます。</p>
              <p>服装を選ばず、きちんと感と品の良さを常にキープしてくれるため、「今日はどのバッグにしよう」と悩む時間を減らしてくれる存在です。</p>
              <p>バッグを持ち替えなくても一日を通して対応できるという実用性の高さも、実際に使うほどに評価が高まる、大きな魅力のひとつです。</p>
            </div>
          </div>
        </div>
      </section>
      <section name="sec9" className="section-content">
        <div className="img-three-cloumn max-width">
          <figure className="img-small">
            <StaticImage src="../../images/posts/64/9.jpg" alt=""/>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/64/10.jpg" alt=""/>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/64/11.jpg" alt=""/>
          </figure>
        </div>
        <span className="text-center">Valextra／Iside<br></br>マイクロ：W20 × H14 × D8 (cm)／ミニ：W22 × H16 × D10 (cm)／ミディアム：W26 × H19 × D11 (cm)</span>
        <div className="mt8">
          <h2>『イジィデ』シリーズ サイズ比較</h2>
        </div>
        <p>用途やライフスタイルに合わせて選べるのもイジィデの魅力です。<br></br>
        ここでは代表的な3サイズを比較します。</p>
        <p>同じデザインをベースにしながらも、サイズが変わることで印象や使い勝手は大きく異なります。収納力だけでなく、持ったときのバランスやスタイリングへの影響もサイズ選びの重要なポイントです。</p>
        <p>「どんなシーンで使いたいか」<br></br>
        「日常で持ち歩く荷物量はどれくらいか」<br></br>
        「装いの主役にしたいか、引き立て役にしたいか」</p>
        <p>こうした視点で見ていくと、自分にとって最適なイジィデが自然と見えてきます。<br></br>
        以下では、それぞれのサイズが持つ特徴と魅力を、実際の使用感を交えながら詳しくご紹介します。</p>
        <div name="sec10" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/64/12.jpg" alt=""/>
          </figure>
          <div className="img-three-cloumn gap">
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/13.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/14.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/15.jpg" alt=""/>
            </figure>
          </div>
          <div className="mt4">
            <h3>◆ マイクロ イジィデ｜アクセサリー感覚で楽しむ最小サイズ<br></br>W20 × H14 × D8（cm）</h3>
          </div>
          <p>マイクロ イジィデは、シリーズの中でも最もコンパクトなサイズです。収納力は必要最低限で、スマートフォン、ミニ財布、リップや鍵といった必需品が収まる程度です。あえて余白を残す設計が、このバッグをより洗練された印象へと導いています。</p>
          <p>実際に持ったときのバランスは非常に秀逸で、身体に対して主張しすぎず、それでいて確かな存在感を放ちます。クロスボディにした際もバッグが悪目立ちせず、コーディネート全体に自然なリズムを生み出します。</p>
          <p>フラップのラインや底鋲の配置など、細部の完成度がダイレクトに伝わり、「小さい＝簡易的」という印象を一切与えません。</p>
          <p>「バッグはコーディネートの一部」と考える方にとって、マイクロ イジィデは非常に満足度の高い選択肢と言えるでしょう。</p>
        </div>
        <div name="sec11" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/64/16.jpg" alt=""/>
          </figure>
          <div className="img-three-cloumn gap">
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/17.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/18.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/19.jpg" alt=""/>
            </figure>
          </div>
          <div className="mt4">
            <h3>◆ ミニ イジィデ｜初めてのイジィデに選ばれる王道サイズ<br></br>W22 × H16 × D10（cm）</h3>
          </div>
          <p>ミニ イジィデは、シリーズの中でも最も支持率が高く、「完成形」とも言えるバランスの良さを備えたサイズです。スマートフォン、二つ折り財布、キーケース、ハンカチ、リップなど、日常の必需品が無理なく収まり、実用性と美しさの両立を叶えてくれます。</p>
          <p>実際に手に持つと分かるのは、そのサイズ以上のきちんと感です。小ぶりでありながら奥行きがあり、フォルムが崩れにくいため、バッグ単体でスタイルを引き締める力があります。フラップのラインや立体感が美しく保たれる点は、イジィデならではの完成度です。</p>
          <p>付属のストラップを使えばショルダーとしても活躍し移動の多い日やカジュアルな装いにも自然に馴染みます。「小さすぎず、大きすぎない」絶妙なサイズ感がオン・オフ問わず使いやすい理由です。</p>
          <p>初めてイジィデを選ぶ方がミニサイズに惹かれるのは、可愛らしさと大人らしさのバランスが非常に優れているからです。フォーマルな場でも浮かず、デニムやニットといった日常着にも寄り添う柔軟さは、まさに王道と呼ぶにふさわしい存在です。長く使える一生モノとして、最初の一つに選ばれる理由が随所に詰まったサイズと言えるでしょう。</p>
        </div>
        <div name="sec12" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/64/20.jpg" alt=""/>
          </figure>
          <div className="img-three-cloumn gap">
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/21.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/22.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/64/23.jpg" alt=""/>
            </figure>
          </div>
          <div className="mt4">
            <h3>◆ ミディアム イジィデ｜仕事にも対応できる大人の実用サイズ<br></br>W26 × H19 × D11（cm）</h3>
          </div>
          <p>ミディアム イジィデは、イジィデシリーズの中でも実用性を最も重視したサイズでありながら、エレガンスを一切損なわない点が大きな魅力です。</p>
          <p>長財布、手帳、ポーチ、スマートフォンに加え、ハンカチやキーケースまでしっかり収納でき、日常に必要なものを無理なく持ち歩くことができます。</p>
          <p>サイズが大きくなることでフォルムが崩れると思われがちですが、イジィデはその心配がありません。側面のマチやフラップのラインが美しく設計されているため、中身を入れてもシルエットは常に端正です。</p>
          <p>特にミディアムサイズは、腕にかけたときの存在感が程よく、コートやジャケットと合わせてもバランスを取りやすいのが特徴です。書類やタブレットほど大きな荷物は不要だけれど、ある程度の収納力は欲しいという方にとって、非常に現実的な選択肢と言えるでしょう。</p>
          <p>また、オンとオフを分けずに使える点も高評価ポイントです。仕事の日はきちんと、休日は少しカジュアルに――「実用性を妥協したくない、でもラグジュアリー感も大切にしたい」という方から支持されるのは、まさにこのミディアムサイズです。</p>
          <p>見た目の美しさと使いやすさのどちらも妥協したくない方にとって、毎日の装いに自然と寄り添い、長く安心して使い続けられるバッグと言えるでしょう。</p>
        </div>
      </section>
      <section name="sec13" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/64/24.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>サイズ違いで広がる、イジィデのコーディネート術</h2>
        </div>
        <p>イジィデは、通勤スタイルから学校行事、レストランでの会食、さらには式典やフォーマルな場まで、幅広いシーンに自然と溶け込む、稀有なバッグです。</p>
        <p>その理由のひとつが、サイズごとに表情や役割が明確で、コーディネートの方向性を自在に変えられる点にあります。</p>
        <p>ここでは、マイクロ・ミニ・ミディアムの3サイズを、それぞれ「きちんと感」と「カジュアル感」の視点から見ていきます。</p>
        <div name="sec14" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/64/25.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ マイクロ イジィデ｜会食・レストランシーンに</h3>
            <p>ネイビーやブラックを基調にした、上品で落ち着いたスタイリングです。<br></br>
            マイクロ イジィデの端正なフォルムが、装い全体を引き締め、会食やきれいめなお出かけにも自然になじみます。小ぶりながらも“整った印象”を添えてくれるのが魅力です。</p>
            <p><span className="text-border-bottom">バッグポイント</span><br></br>
            コンパクトなサイズ感ながら、必要最低限のアイテムがすっきり収まり、装いを邪魔せず、洗練された印象をキープできます。</p>
          </div>
          <div name="sec15" className="mt4">
            <h3>◆ マイクロ イジィデ｜週末のお出かけ・近場外出に</h3>
            <p>淡色やニット素材を取り入れた、やわらかな雰囲気のスタイリングです。<br></br>
            マイクロ イジィデを合わせることで、ラフになりすぎず、ほどよい品の良さをプラスします。<br></br>
            日常のお出かけや週末スタイルにも取り入れやすい組み合わせです。</p>
            <p><span className="text-border-bottom">バッグポイント</span><br></br>
            アクセサリー感覚で取り入れられ、カジュアルな装いに自然なきちんと感を添えてくれます。</p>
          </div>
        </div>
        <div name="sec16" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/64/26.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ ミニ イジィデ｜通勤・仕事帰りの予定がある日に</h3>
            <p>ワントーンカラーでまとめた、やさしく上品なスタイリングです。<br></br>
            ミニ イジィデは程よいサイズ感があり、装いに落ち着きと安心感を与えてくれます。<br></br>
            きれいめなパンツスタイルやブーツと合わせることで、通勤や仕事帰りの予定がある日にも対応できるバランスです。</p>
            <p><span className="text-border-bottom">バッグポイント</span><br></br>
            最も汎用性の高い“万能サイズ”です。コンパクトすぎず、必要な持ち物がしっかり収まるサイズで、上品さと実用性を両立した印象です。</p>
          </div>
          <div name="sec17" className="mt4">
            <h3>◆ ミニ イジィデ｜ショッピング・街歩きに</h3>
            <p>デニムやニットを合わせた、程よく力の抜けたスタイリングです。<br></br>
            ミニ イジィデの端正なフォルムが、カジュアルな装いに自然な“きちんと感”をプラスします。<br></br>
            普段のおでかけや週末スタイルにも取り入れやすい組み合わせです。</p>
            <p><span className="text-border-bottom">バッグポイント</span><br></br>
            主張しすぎないサイズ感だからこそ、カジュアルな服装でも品よくまとまります。<br></br>
            バッグサイズに迷ったらミニサイズがお勧めです。</p>
          </div>
        </div>
        <div name="sec18" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/64/27.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ ミディアム イジィデ｜通勤・学校行事などきちんとした日に</h3>
            <p>淡いトーンのジャケットや軽やかなコートに合わせて、全体をやさしくまとめたスタイリングです。<br></br>
            ミディアム イジィデは、必要なものだけを美しく収められるサイズ感で、控えめながらも確かな存在感を放ちます。通勤や会食、学校行事など、きちんと感が求められる場面でも安心して持てるバランスです</p>
            <p><span className="text-border-bottom">バッグポイント</span><br></br>
            書類や手帳、長財布なども収まり、見た目の美しさと実用性を両立できるサイズ感です。</p>
          </div>
          <div name="sec19" className="mt4">
            <h3>◆ ミディアム イジィデ｜休日のお出かけ・長時間の外出に</h3>
            <p>スウェットのセットアップで合わせた、肩の力を抜いたスタイリングです。<br></br>
            カジュアルなアイテムと合わせても、ミディアム イジィデの構築的なフォルムが全体を上品にまとめてくれます。普段使いから週末のお出かけまで、幅広く活躍します。</p>
            <p><span className="text-border-bottom">バッグポイント</span><br></br>
            収納力がありながらラフになりすぎない大人のカジュアルにちょうどいい存在感です。</p>
          </div>
        </div>
      </section>
      <section name="sec20" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/64/28.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>イジィデの「カラーバリエーション」定番色から選ぶ大人の最適解</h2>
        </div>
        <p>ヴァレクストラのアイコンバッグ「イジィデ」は、クラシックなデザインに加え、豊富なカラーバリエーションも大きな魅力のひとつです。ベーシックな定番色から、装いにさりげない個性を添えるカラーまで幅広く展開されており、自分らしさや季節感に合わせて選べる楽しさがあります。</p>
        <p>中でも、ブランドを象徴するカラーである「Pergamena White（ペルガメーナホワイト）」は、清潔感と上品さを兼ね備えた万能カラーとして高い評価を受けています。通勤スタイルから学校行事、会食、フォーマルなシーンまで幅広く対応でき、初めてのイジィデとしても選ばれることの多いカラーです。</p>
        <p>まずは定番カラーでイジィデの魅力を楽しみ、慣れてきたらアクセントカラーを取り入れることで、より自分らしいスタイルへと広げていくのもおすすめです。</p>
        <div name="sec21" className="mt8">
          <h3>◆ Pergamena White — ヴァレクストラを象徴するカラー</h3>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/64/29.jpg" alt=""/>
            </figure>
            <div>
              <p>ブランドのアイコンとも言えるカラーが、ペルガメーナホワイトです。</p>
              <p>清潔感と上品さを兼ね備え、ビジネスからカジュアルまで幅広く対応できる万能カラーとして、常に人気の上位にランクインしています。</p>
              <p>ホワイトは光を受けて印象が変わり、コーディネートを明るく見せる効果もあります。特に淡色やニュートラルカラーと合わせれば、フェミニンで洗練された雰囲気に。</p>
              <p>秋冬はコートの陰影とも調和し、春夏は軽やかな装いにもマッチします。</p>
            </div>
          </div>
        </div>
        <div name="sec22" className="mt4">
          <h3>◆ Black — シーンを選ばない不動の定番カラー</h3>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/64/30.jpg" alt=""/>
            </figure>
            <div>
              <p>イジィデの美しい構築フォルムを最もシャープに引き立てるのが、定番のブラックです。</p>
              <p>無駄を削ぎ落としたデザインだからこそ、黒の持つ深みと端正さが際立ち、ビジネスシーンでは知的で信頼感のある印象に。フォーマルな場面でも浮くことなく、装い全体を引き締めてくれます。</p>
              <p>また、季節を問わず使いやすいのもブラックの魅力。秋冬はダークトーンのコートと調和し、春夏は装いにメリハリを与える存在として活躍します。</p>
              <p>「まず1つ選ぶなら間違いのない色」として、長く支持され続けています。</p>
            </div>
          </div>
        </div>
        <div name="sec23" className="mt4">
          <h3>◆ Gray — 洗練と柔らかさを兼ね備えた万能カラー</h3>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/64/31.jpg" alt=""/>
            </figure>
            <div>
              <p>グレー系のイジィデは、上品さと柔らかさを併せ持つ、非常にバランスの良いカラーです。</p>
              <p>ブラックほど強さを出さず、ホワイトほど軽やかすぎないため、モノトーンを中心としたワードローブに自然に溶け込みます。</p>
              <p>淡いグレーは知的で穏やかな印象を与え、オフィスシーンにも好相性。濃淡のあるコートやニットと合わせれば、立体感のあるスタイリングが完成します。</p>
              <p>主張しすぎず、それでいて確かな存在感を放つ色として、大人の女性から高い支持を集めています。</p>
            </div>
          </div>
        </div>
      </section>
      <section name="sec24" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/64/32.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>まとめ：イジィデは「今」ではなく「これから」を支えるバッグ</h2>
        </div>
        <p>ヴァレクストラ《イジィデ》は、<br></br>
        写真映えを狙った華やかさや一過性のトレンドとは距離を置いたバッグです。</p>
        <p>それでも多くの女性に選ばれ続けているのは、年齢やライフステージの変化に静かに寄り添い、使う人の装いと価値観を受け止めてくれる包容力があるからでしょう。</p>
        <p>クローゼットにひとつあるだけで、「今日は何を持とう」と迷う時間が減り、どんな場面でも自然と整った印象をつくってくれる。<br></br>
        イジィデは、そうした“信頼できる基準”のような存在です。</p>
        <p>実際に、セレモニーや節目のタイミングをきっかけに手にする方も多いものの、その真価が発揮されるのは購入後です。フォーマルな場はもちろん、通勤や学校行事、きれいめカジュアルまで、想像以上に幅広いシーンで活躍してくれます。</p>
        <p>流行に左右されず、長く使い続けられること。<br></br>
        装いを選ばず、その人らしさを引き立ててくれること。</p>
        <p>次に迎える“一生もの”のブランドバッグとして、イジィデはぜひ心に留めておきたい存在です。<br></br>
        今の自分だけでなく、これからの自分にも寄り添ってくれる——そんなバッグを探している方にこそ、ふさわしい名品と言えるでしょう。</p>
        <p className="mt4"><span className="text-border-bottom">Valextra（ヴァレクストラ）の《Iside（イジィデ）》はどこで借りられる？</span></p>
        <p>価格も高額で、簡単には手に取りにくいヴァレクストラのバッグ。<br></br>
        「試してみたいけれど、買うには勇気がいる」──そんな方におすすめなのが、ブランドバッグシェアリングサービス「ラクサス」です。<br></br>
        アプリで簡単に注文でき、自宅にいながら憧れのブランドバッグを楽しめます。</p>
        <div className="border"></div>
        <p>📱憧れを日常に──ラクサスでヴァレクストラを体験しよう！</p>     
        <Link to="https://laxus.co/app/pc/bags/valextra" className="view-all-button">ヴァレクストラのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post64

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 64}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`